module.exports = __webpack_public_path__ + "images/landing/video-previews/Bakery_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/Bakery_2x.jpg
// module id = UD7f
// module chunks = 1